module.exports = __webpack_public_path__ + "img/man-with-laptop.1fb03ce4.png";